module.exports = __webpack_public_path__ + "img/special3.84117eb9.png";